/** @format */

import React from "react";
import { useNavigate } from "react-router-dom";

import { Formik, Form } from "formik";
import FormControl from "../forms/FormControl";
import Button from "./Button";
import { MdCancel } from "react-icons/md";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";
import { useAuth } from "../context/AuthContext";
import { auth, db, updateProfile } from "../firebase/utils";
import { ACTIONS } from "../reducer/authReducer";

const Signup = () => {
  //FUNCTIONS FROM AUTHCONTEXT
  const { authState, handleHidePopup, registerNewUser, dispatch, closeToast } =
    useAuth();
  const { signupPopupState } = authState;

  let navigate = useNavigate();

  //INITIALVALUES REQUIRED BY REACT FORMIK LIB
  const initialValues = {
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  };

  //YUP FORM VALIDATION SCHEMA
  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    email: Yup.string().email().required("Required"),
    password: Yup.string().min(6).required("Required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), ""])
      .required("Required"),
  });

  //ON SUBMIT FORMIK OBJECT
  const onSubmit = (values, onSubmitProps) => {
    const { name, email, password } = values;
    const { setSubmitting } = onSubmitProps;
    registerNewUser(auth, email, password)
      .then(
        async (param) => (
          //SET USER PROFILE NAME SUCCESSFUL REGISTRATION IN FIREBASE AUTH
          await updateProfile(auth.currentUser, {
            displayName: name,
          }),
          dispatch({ type: ACTIONS.SET_TOAST_SUCCESSFULL }),
          navigate("/profile-update"),
          closeToast(),
          onSubmitProps.resetForm(),
          handleHidePopup()
        )
      )
      .catch(
        (err) => (
          dispatch({ type: ACTIONS.SET_TOAST_FAILURE }),
          //WHEN THERE IS AN ERROR SET SUBMITTING TO FALSE
          setSubmitting(false),
          //TOAST TO SHOW FAILURE OR SUCCESS
          closeToast(),
          console.log(`"Found some errors ${err}`)
        )
      );
  };

  if (signupPopupState) {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <div className="signup__form">
              <Form className="form">
                <div className="form__title--container">
                  <h2 className="form__title">SIGN UP</h2>
                  <MdCancel
                    onClick={handleHidePopup}
                    style={{ color: "rgb(202,8,8)", fontSize: "1.2rem" }}
                  />
                </div>
                <hr />

                <FormControl
                  control="input"
                  name="name"
                  label="Full Name (Guardian/Parent)"
                  placeholder="please enter full name"
                  type="text"
                />
                <FormControl
                  control="input"
                  name="email"
                  label="Email"
                  placeholder="please enter email"
                  type="text"
                />

                <FormControl
                  control="input"
                  name="password"
                  label="Password"
                  type="password"
                  placeholder="please enter password"
                />

                <FormControl
                  control="input"
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  placeholder="confirm password"
                />
                <div className="submit__button">
                  <Button
                    btnText={
                      formik.isSubmitting ? (
                        <FaSpinner className="spinner"></FaSpinner>
                      ) : (
                        "Submit"
                      )
                    }
                    color="#fff"
                    type="submit"
                    bg="var(--success)"
                    btnBlock
                    disabled={!formik.isValid || formik.isSubmitting}
                  ></Button>
                  {!formik.isValid && (
                    <small style={{ color: "red", textAlign: "center" }}>
                      kindly fill all fields...
                    </small>
                  )}
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
    );
  } else {
    return <div></div>;
  }
};

export default Signup;
